// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { FlagGroup as AKFlagGroup } from '@atlaskit/flag';

export type FlagGroupProps = ComponentProps<typeof AKFlagGroup>;

const FlagGroup = (props: FlagGroupProps) => {
	if (__SERVER__) {
		return null;
	}

	return <AKFlagGroup {...props} />;
};

export default FlagGroup;

export type FlagGroupType = typeof FlagGroup;
